import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-cart-v2',
  templateUrl: './cart-v2.component.html',
  styleUrls: ['./cart-v2.component.scss']
})
export class CartV2Component {}
